import { Attribute, Component } from '../../../concepts/objects';

export const CommentCountAttr = new Attribute<number, Component>('commentCount', 0);
export const CommentOpenAttr = new Attribute<boolean, Component>('commentOpen', false);
